<template>
  <div>
    <el-form label-width="60" inline class="elementui-common-form-styles" v-highlight>
      <el-form-item label="任务状态">
        <ElSelect v-model="queryForm.status" style="width: 160px" clearable @change="onQueryAction">
          <ElOption :value="0" label="未开始"></ElOption>
          <ElOption :value="1" label="执行中"></ElOption>
          <ElOption :value="2" label="成功"></ElOption>
          <ElOption :value="3" label="失败"></ElOption>
        </ElSelect>
      </el-form-item>
      <el-button type="primary" @click="onQueryAction">查询</el-button>
    </el-form>

    <Viewport v-model="tableHeight">
      <el-table v-loading="tableLoading" class="common-el-table-styles" border stripe :data="tableData" :height="tableHeight">
        <el-table-column prop="taskId" label="任务ID" width="60"> </el-table-column>
        <el-table-column prop="tagId" label="标签ID" width="60"> </el-table-column>
        <el-table-column prop="mediaName" label="媒体" width="80" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="mediaTagName" label="媒体标签名称" width="140" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="mediaTagId" label="媒体标签ID" width="90" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="accountName" label="媒体账号" width="220" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="materialName" label="素材名称" width="260" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="createTimeText" label="创建时间" width="140"> </el-table-column>
        <el-table-column prop="createOpName" label="创建人" width="90"> </el-table-column>
        <el-table-column prop="updateTimeText" label="更新时间" width="140"> </el-table-column>
        <el-table-column prop="statusName" label="状态" width="70"> </el-table-column>
        <el-table-column prop="msg" label="失败原因" show-overflow-tooltip> </el-table-column>
        <el-table-column label="操作" width="90">
          <template slot-scope="{ row }">
            <el-button type="text" v-if="row.taskStatus === 3" @click="onTaskRetry(row)">重试</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pager">
        <el-pagination
          :current-page.sync="pager.pageIndex"
          :page-size.sync="pager.pageSize"
          :total="total"
          :page-sizes="[30, 50, 100, 200]"
          @current-change="getTableData"
          @size-change="onQueryAction"
          layout="total, sizes, prev, pager, next, jumper"
          background
        >
        </el-pagination>
      </div>
    </Viewport>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import moment from 'moment'
import { getMediaTagProgress, mediaTagTaskRetry } from '@/api/material.model.js'
import { useRoute } from 'vue-router/composables'

const route = useRoute()
const tableHeight = ref(500)
const total = ref(0)
const queryForm = ref({ status: '' })
const pager = ref({
  pageIndex: 1,
  pageSize: 30
})
const tableData = ref([])
const tableLoading = ref(false)

function getTableData() {
  tableLoading.value = true
  getMediaTagProgress({ ...pager.value, ...queryForm.value, tagId: route.query?.tagId || '' })
    .then((data) => {
      const { list, page_info } = data
      if (list) {
        tableData.value = list.map((row) => {
          return {
            ...row,
            createTimeText: row.createTime ? moment(row.createTime).format('YYYY-MM-DD HH:mm:ss') : '',
            updateTimeText: row.updateTime ? moment(row.updateTime).format('YYYY-MM-DD HH:mm:ss') : ''
          }
        })
        total.value = page_info.total_number || 0
      }
    })
    .finally(() => {
      tableLoading.value = false
    })
}
function onQueryAction() {
  pager.value.pageIndex = 1
  getTableData()
}
function onTaskRetry(row) {
  mediaTagTaskRetry({ taskId: row.taskId }).then((data) => {
    if (data) {
      getTableData()
    }
  })
}
onQueryAction()
</script>

<style scoped lang="scss">
.pager {
  text-align: right;
  padding: 5px 0;
}
</style>
